module.exports = __webpack_public_path__ + "static/img/zhangxinyuan.6dbdd98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/touxiang/zhangxinyuan.png
// module id = Q8N2
// module chunks = 0